import { render, staticRenderFns } from "./myAds.vue?vue&type=template&id=2afcc008&scoped=true"
import script from "./myAds.vue?vue&type=script&lang=js"
export * from "./myAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afcc008",
  null
  
)

export default component.exports